<template>
  <div class="left-widgets__wrapper" :class="open ? 'open' : ''">
    <div class="widget-toggle__wrapper">
      <v-btn icon dark class="toggle__btn" @click="open = !open">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
    <IPTracker :open="open" class="ip-tracker" />
    <TotalAttackCount :open="open" />
  </div>
</template>

<script>
import IPTracker from 'Components/IPTracker';
import TotalAttackCount from 'Components/TotalAttackCount';

export default {
  name: 'LeftWidgetsContainer',
  components: {
    IPTracker,
    TotalAttackCount
  },
  data: () => {
    return {
      open: false
    };
  }
};
</script>

<style lang="scss" scoped>
@import 'Plugins/style/breakpoints';

.left-widgets__wrapper {
  pointer-events: none;
  position: absolute;
  left: 1em;
  top: 33%;
  width: 150px;
  overflow: hidden;
  transition: width 0.4s ease-in-out;
  padding: 40px 1em 1em 1em;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.2);

  .widget-toggle__wrapper {
    position: absolute;
    top: 0;
    right: 0;
    .toggle__btn {
      pointer-events: all;
    }
  }

  .ip-tracker {
    margin: 0 0 12px 0;
  }

  &.open {
    width: 200px;

    .widget-toggle__wrapper {
      .toggle__btn {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
